const ConsoleColor = {
    RED: '\x1b[41m',
    GREEN: '\x1b[42m',
    YELLOW: '\x1b[43m',
    BLUE: '\x1b[44m',
    MAGENTA: '\x1b[45m',
    CYAN: '\x1b[46m',
    WHITE: '\x1b[47m',
    BRIGHT_RED: '\x1b[101m',
    BRIGHT_GREEN: '\x1b[102m',
    BRIGHT_YELLOW: '\x1b[103m',
    BRIGHT_BLUE: '\x1b[104m',
    BRIGHT_MAGENTA: '\x1b[105m',
    BRIGHT_CYAN: '\x1b[106m',
    BRIGHT_WHITE: '\x1b[107m',
    BLACK: '\x1b[40m',
    BRIGHT_BLACK: '\x1b[100m',
    ORANGE: '\x1b[48;5;208m',
    PURPLE: '\x1b[48;5;129m',
    PINK: '\x1b[48;5;205m',
    LIME: '\x1b[48;5;154m',
    TEAL: '\x1b[48;5;51m',
    NAVY: '\x1b[48;5;17m',
    MAROON: '\x1b[48;5;88m',
    OLIVE: '\x1b[48;5;100m'
} as const

export function bigColorfulConsoleLog(message: string, color: keyof typeof ConsoleColor = 'RED', lines: number = 5) {
    const reset = '\x1b[0m'
    const bold = '\x1b[1m'
    const fullWidth = 120
    const upperMessage = message.toUpperCase()
    const padding = Math.max(0, Math.floor((fullWidth - upperMessage.length) / 2))
    const centeredMessage = ' '.repeat(padding) + upperMessage + ' '.repeat(fullWidth - padding - upperMessage.length)

    console.log('\n'.repeat(lines))
    console.log(`${ConsoleColor[color]}${bold}${'='.repeat(fullWidth)}${reset}`)
    console.log(`${ConsoleColor[color]}${bold}${' '.repeat(fullWidth)}${reset}`)
    console.log(`${ConsoleColor[color]}${bold}${' '.repeat(fullWidth)}${reset}`)
    console.log(`${ConsoleColor[color]}${bold}${' '.repeat(fullWidth)}${reset}`)
    console.log(`${ConsoleColor[color]}${bold}${centeredMessage}${reset}`)
    console.log(`${ConsoleColor[color]}${bold}${' '.repeat(fullWidth)}${reset}`)
    console.log(`${ConsoleColor[color]}${bold}${' '.repeat(fullWidth)}${reset}`)
    console.log(`${ConsoleColor[color]}${bold}${' '.repeat(fullWidth)}${reset}`)
    console.log(`${ConsoleColor[color]}${bold}${' '.repeat(fullWidth)}${reset}`)
    console.log(`${ConsoleColor[color]}${bold}${'='.repeat(fullWidth)}${reset}`)
    console.log('\n'.repeat(lines))
}